import React, { useState, useEffect } from "react";
import { Card, Spin, Row, Col, Divider, Typography, Tag, message } from "antd";
import SchoolService from "../../services/school";

const { Title, Text } = Typography;

const SchoolAdminDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [school, setSchool] = useState(null);

  useEffect(() => {
    fetchSchoolData();
  }, []);

  const fetchSchoolData = async () => {
    setLoading(true);
    try {
      const res = await SchoolService.getCurrentSchool();
      if (res && res.success) {
        setSchool(res.school);
      } else {
        message.error("Failed to fetch school data");
      }
    } catch (err) {
      console.error("Error fetching school data:", err);
      message.error("Unable to load school data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Spin size="large" style={{ display: "block", margin: "50px auto" }} />;
  }

  if (!school) {
    return <Text>No school data available</Text>;
  }

  return (
    <div className="school-dashboard">
      <Card title="School Dashboard">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Text strong>Name:</Text> <Text>{school.name}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Primary Email:</Text> <Text>{school.primaryEmail}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Primary Phone:</Text> <Text>{school.primaryPhone}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Location:</Text> <Text>{school.city}, {school.country}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Membership Tier:</Text> <Text>{school.membershipTier}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Staff Limit:</Text> <Text>{school.staffLimit ?? "N/A"}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Current Staff:</Text> <Text>{school.currentStaffCount || 0}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Contract Start:</Text>{" "}
            <Text>
              {school.startDate ? new Date(school.startDate).toLocaleDateString() : "N/A"}
            </Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Contract Expiry:</Text>{" "}
            <Text>
              {school.expiryDate ? new Date(school.expiryDate).toLocaleDateString() : "N/A"}
            </Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Remaining Days:</Text>{" "}
            <Text>{school.remainingDays === null ? "N/A" : school.remainingDays}</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Registration:</Text>{" "}
            <Tag color={school.registrationStatus === "approved" ? "green" : school.registrationStatus === "pending" ? "orange" : "red"}>
              {school.registrationStatus}
            </Tag>
          </Col>
          <Col xs={24} sm={12}>
            <Text strong>Status:</Text>{" "}
            <Tag color={school.isActive ? "green" : "red"}>
              {school.isActive ? "Active" : "Expired"}
            </Tag>
          </Col>
        </Row>
        <Divider />
      </Card>
    </div>
  );
};

export default SchoolAdminDashboard;
